"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _optionsContext = require("./options-context");

var _jsxFileName = "/home/circleci/project/src/components/auto-gen-crumb.js";

var AutoGenCrumb = function AutoGenCrumb(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      crumbSeparator = _ref.crumbSeparator,
      crumbWrapperStyle = _ref.crumbWrapperStyle,
      crumbActiveStyle = _ref.crumbActiveStyle,
      crumbStyle = _ref.crumbStyle,
      autoGenCrumbs = _ref.crumbs,
      _ref$crumbLabel = _ref.crumbLabel,
      crumbLabelOverride = _ref$crumbLabel === void 0 ? null : _ref$crumbLabel,
      disableLinks = _ref.disableLinks,
      hiddenCrumbs = _ref.hiddenCrumbs,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["title", "crumbSeparator", "crumbWrapperStyle", "crumbActiveStyle", "crumbStyle", "crumbs", "crumbLabel", "disableLinks", "hiddenCrumbs"]);

  var _React$useContext = _react.default.useContext(_optionsContext.OptionsContext),
      useClassNames = _React$useContext.useClassNames;

  return _react.default.createElement("div", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  }, _react.default.createElement("span", {
    className: "breadcrumb__title",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }, title), autoGenCrumbs.map(function (c, i) {
    if (hiddenCrumbs.includes(c.pathname)) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "breadcrumb",
      style: useClassNames ? null : (0, _extends2.default)({
        display: 'inline'
      }, crumbWrapperStyle),
      key: i,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30
      },
      __self: this
    }, !disableLinks.includes(c.pathname) && _react.default.createElement(_gatsby.Link, (0, _extends2.default)({
      to: c.pathname,
      style: useClassNames ? null : (0, _extends2.default)({
        textDecoration: 'none',
        fontSize: '16pt',
        color: '#e1e1e1'
      }, crumbStyle),
      activeStyle: useClassNames ? null : (0, _extends2.default)({
        color: 'white'
      }, crumbActiveStyle),
      className: "breadcrumb__link",
      activeClassName: useClassNames ? 'breadcrumb__link__active' : null
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38
      },
      __self: this
    }), crumbLabelOverride && i === autoGenCrumbs.length - 1 ? crumbLabelOverride : c.crumbLabel), disableLinks.includes(c.pathname) && _react.default.createElement("span", (0, _extends2.default)({
      style: useClassNames ? null : (0, _extends2.default)({
        textDecoration: 'none',
        fontSize: '16pt',
        color: '#e1e1e1'
      }, crumbStyle),
      className: "breadcrumb__link__disabled"
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70
      },
      __self: this
    }), crumbLabelOverride && i === autoGenCrumbs.length - 1 ? crumbLabelOverride : c.crumbLabel), _react.default.createElement("span", {
      className: "breadcrumb__separator",
      style: useClassNames ? null : (0, _extends2.default)({
        fontSize: '16pt'
      }, crumbStyle),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89
      },
      __self: this
    }, i === autoGenCrumbs.length - 1 ? null : crumbSeparator));
  }));
};

AutoGenCrumb.defaultProps = {
  title: '',
  crumbSeparator: ' / ',
  crumbWrapperStyle: {},
  crumbStyle: {},
  crumbActiveStyle: {},
  crumbLabel: null,
  disableLinks: [],
  hiddenCrumbs: []
};
AutoGenCrumb.propTypes = {
  title: _propTypes.default.string,
  crumbSeparator: _propTypes.default.string,
  crumbWrapperStyle: _propTypes.default.shape(),
  crumbActiveStyle: _propTypes.default.shape(),
  crumbStyle: _propTypes.default.shape(),
  crumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    location: _propTypes.default.shape(),
    pathname: _propTypes.default.string.isRequired
  })).isRequired,
  crumbLabel: _propTypes.default.string,
  disableLinks: _propTypes.default.arrayOf(_propTypes.default.string),
  hiddenCrumbs: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = AutoGenCrumb;
exports.default = _default;